<template>
    <div class="TQ_center TQ_bg_white TQ_maxWidth_700px TQ_minHeight_bodyFullScreen">

        <!-- rules -->
        <div v-if="server_questBody_c !== undefined"
             class="TQ_center TQ_padding_16px"
             v-html="server_questBody_c.qb_questRules_byLangCode_c[co_questBody_displayLangCode_e].w_body_s"> </div>
        <ball-pulse-sync-loader v-else color="#2E294E" size="10px"/>

    </div>
</template>

<script>
    import {ass_strings}                from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {store_getStateValue_vo}        from "../../store";
    import {store_var}         from "../../store";
    import {serverBig_questBody_once_fp}   from "../../scripts/Server/S_ServerFirestore";
    import {enum_serverRequestType} from "../../../functions/src/shareCode/Share_S_Enum";

    export default {
        name: "V_Ongoing_QuestRules",
        data(){
            return {

                // server
                server_questBody_c          : undefined,

                // store
                store_system_langCode_ve    : store_getStateValue_vo(store_var.system_langCode),
                store_questEvent_c          : store_getStateValue_vo(store_var.ongoing_questEvent).val,

                // assents
                ass_strings : ass_strings

            }
        },
        computed:{
            co_questBody_displayLangCode_e(){
                return this.server_questBody_c.cm_qb_getDisplayLangCode_e(this.store_system_langCode_ve.val)
            }
        },
        mounted(){
            serverBig_questBody_once_fp(this.store_questEvent_c.qev_questType_e, this.store_questEvent_c.qev_questId_uid, false, true,(questBody_c) => {
                this.server_questBody_c = questBody_c
            })
        }


    }
</script>

<style scoped>

</style>